jQuery(document).ready(function ($) {

	let isVisible = false;
	jQuery("#store_displaybtn span.elementor-button-text").click(function () {
		if (isVisible) {
			jQuery("#popup").css("left", "-500px");
		} else {
			jQuery("#popup").css("left", "0");
		}
		isVisible = !isVisible;
	});
	// jQuery("#popup").addClass("show");
	jQuery("#closebtn a").click(function () {
		//jQuery("#popup").removeClass("show");
		jQuery("#popup").css("left", "-500px");
	});


	// Set initial cookie value if it doesn't exist
	if (!Cookies.get('myCookie')) {
		Cookies.set('myCookie', 'Eliot Menu');
	}

	// Set cookie value as per store location start

	if (window.location.pathname.includes("/eliot-menu/") && window.location.hostname === "eccannabis.com") {
		Cookies.set('myCookie', 'Eliot Menu');
		var cookieValue = Cookies.set('myCookie', '8be63bcd-71d8-426d-8a38-752c547405e7');
	}

	if (window.location.pathname.includes("lebanon-menu/") && window.location.hostname === "eccannabis.com") {
		Cookies.set('myCookie', 'Lebanon Menu');
		var cookieValue = Cookies.set('myCookie', 'cd264a5c-b29d-40fc-8d1d-f677420cd0c5');
	}

	if (window.location.pathname.includes("/waterville-menu/") && window.location.hostname === "eccannabis.com") {
		Cookies.set('myCookie', 'Waterville Menu');
		var cookieValue = Cookies.set('myCookie', 'd26049d4-9c0e-4dba-a43c-5e1103a3b8ee');
	}
	// Set cookie value as per store location end


	var cookieValue = Cookies.get('myCookie');
	jQuery('#store_displaybtn span.elementor-button-text').text(cookieValue);

	// Get cookie value and display it
	var cookieValue = Cookies.get('myCookie');
	jQuery("#store_displaybtn span.elementor-button-text").attr('data-id', 'eliot-menu');



	jQuery("#bestsellers_wrapper .bseller_eliot, #staff_picks_wrapper_home .staff_picks_eliot").removeClass('hideme');
	jQuery("#bestsellers_wrapper .bseller_lebanon,#bestsellers_wrapper .bseller_waterville, #staff_picks_wrapper_home .staff_picks_lebanon,#staff_picks_wrapper_home .staff_picks_waterville").addClass('hideme');

	jQuery("#shop_apparel_wrapper #eliot_merch").removeClass('hideme');
	jQuery("#shop_apparel_wrapper #lebanon_merch, #shop_apparel_wrapper #waterville_merch").addClass('hideme');

	/*=====Slider linking code=======*/
	$('#twocol_slider .swiper-slide').each(function () {
		const grabbtn_url = $(this).find('a.elementor-button').attr('href');
		var newstore_url = grabbtn_url;
		newstore_url = newstore_url.replace("/lebanon-menu/", "/eliot-menu/");
		newstore_url = newstore_url.replace("/waterville-menu/", "/eliot-menu/");
		$(this).find('a.elementor-button').attr('href', newstore_url);
	});

	$('#home_shop_grid_section .arrow_button').each(function () {
		const grabshopbtn_url = $(this).find('a').attr('href');
		var newshopstore_url = grabshopbtn_url;
		newshopstore_url = newshopstore_url.replace("/lebanon-menu/", "/eliot-menu/");
		newshopstore_url = newshopstore_url.replace("/waterville-menu/", "/eliot-menu/");
		$(this).find('a').attr('href', newshopstore_url);
	});

	/*=====Slider linking codee end=======*/


	if (cookieValue == '8be63bcd-71d8-426d-8a38-752c547405e7') {
		jQuery("#store_displaybtn span.elementor-button-text").html('Eliot Menu');

		jQuery("header .elementor-element.lebanon-menu, header .elementor-element.waterville-menu").hide();
		jQuery("header .elementor-element.eliot-menu").show();
		jQuery("#topright_menu ul li.menu-item.lebanon_shop_menu,#topright_menu ul li.menu-item.waterville_shop_menu").hide();
		jQuery("#topright_menu ul li.menu-item.eliot_shop_menu").css('display', 'flex');

		jQuery("#bestsellers_wrapper .bseller_eliot, #staff_picks_wrapper_home .staff_picks_eliot").removeClass('hideme');
		jQuery("#bestsellers_wrapper .bseller_lebanon,#bestsellers_wrapper .bseller_waterville, #staff_picks_wrapper_home .staff_picks_lebanon,#staff_picks_wrapper_home .staff_picks_waterville").addClass('hideme');

		jQuery("#shop_apparel_wrapper #eliot_merch").removeClass('hideme');
		jQuery("#shop_apparel_wrapper #lebanon_merch, #shop_apparel_wrapper #waterville_merch").addClass('hideme');

		/*=====Slider linking code=======*/
		$('#twocol_slider .swiper-slide').each(function () {
			const grabbtn_url = $(this).find('a.elementor-button').attr('href');
			var newstore_url = grabbtn_url;
			newstore_url = newstore_url.replace("/lebanon-menu/", "/eliot-menu/");
			newstore_url = newstore_url.replace("/waterville-menu/", "/eliot-menu/");
			$(this).find('a.elementor-button').attr('href', newstore_url);
		});

		$('#home_shop_grid_section .arrow_button').each(function () {
			const grabshopbtn_url = $(this).find('a').attr('href');
			var newshopstore_url = grabshopbtn_url;
			newshopstore_url = newshopstore_url.replace("/lebanon-menu/", "/eliot-menu/");
			newshopstore_url = newshopstore_url.replace("/waterville-menu/", "/eliot-menu/");
			$(this).find('a').attr('href', newshopstore_url);
		});

		/*=====Slider linking codee end=======*/

	}
	else if (cookieValue == 'cd264a5c-b29d-40fc-8d1d-f677420cd0c5') {
		jQuery("#store_displaybtn span.elementor-button-text").html('Lebanon Menu');
		jQuery("#store_displaybtn span.elementor-button-text").attr('data-id', 'lebanon-menu');
		jQuery("header .elementor-element.eliot-menu, header .elementor-element.waterville-menu").hide();
		jQuery("header .elementor-element.lebanon-menu").show();
		jQuery("#topright_menu ul li.menu-item.eliot_shop_menu,#topright_menu ul li.menu-item.waterville_shop_menu").hide();
		jQuery("#topright_menu ul li.menu-item.lebanon_shop_menu").css('display', 'flex');

		jQuery("#bestsellers_wrapper .bseller_lebanon, #staff_picks_wrapper_home .staff_picks_lebanon").removeClass('hideme');
		jQuery("#bestsellers_wrapper .bseller_eliot,#bestsellers_wrapper .bseller_waterville, #staff_picks_wrapper_home .staff_picks_eliot,#staff_picks_wrapper_home .staff_picks_waterville").addClass('hideme');

		jQuery("#shop_apparel_wrapper #lebanon_merch").removeClass('hideme');
		jQuery("#shop_apparel_wrapper #eliot_merch, #shop_apparel_wrapper #waterville_merch").addClass('hideme');

		/*=====Slider linking code=======*/
		$('#twocol_slider .swiper-slide').each(function () {
			const grabbtn_url = $(this).find('a.elementor-button').attr('href');
			var newstore_url = grabbtn_url;
			newstore_url = newstore_url.replace("/eliot-menu/", "/lebanon-menu/");
			newstore_url = newstore_url.replace("/waterville-menu/", "/lebanon-menu/");
			$(this).find('a.elementor-button').attr('href', newstore_url);
		});

		$('#home_shop_grid_section .arrow_button').each(function () {
			const grabshopbtn_url = $(this).find('a').attr('href');
			var newshopstore_url = grabshopbtn_url;
			newshopstore_url = newshopstore_url.replace("/eliot-menu/", "/lebanon-menu/");
			newshopstore_url = newshopstore_url.replace("/waterville-menu/", "/lebanon-menu/");
			$(this).find('a').attr('href', newshopstore_url);
		});
		/*=====Slider linking codee end=======*/

	}
	else if (cookieValue == 'd26049d4-9c0e-4dba-a43c-5e1103a3b8ee') {
		jQuery('#store_displaybtn span.elementor-button-text').html('Waterville Menu');
		jQuery("#store_displaybtn span.elementor-button-text").attr('data-id', 'waterville-menu');
		jQuery("header .elementor-element.lebanon-menu, header .elementor-element.eliot-menu").hide();
		jQuery("header .elementor-element.waterville-menu").show();
		jQuery("#topright_menu ul li.menu-item.lebanon_shop_menu,#topright_menu ul li.menu-item.eliot_shop_menu").hide();
		jQuery("#topright_menu ul li.menu-item.waterville_shop_menu").css('display', 'flex');

		jQuery("#bestsellers_wrapper .bseller_waterville, #staff_picks_wrapper_home .staff_picks_waterville").removeClass('hideme');
		jQuery("#bestsellers_wrapper .bseller_eliot,#bestsellers_wrapper .bseller_lebanon, #staff_picks_wrapper_home .staff_picks_eliot,#staff_picks_wrapper_home .staff_picks_lebanon").addClass('hideme');

		jQuery("#shop_apparel_wrapper #waterville_merch").removeClass('hideme');
		jQuery("#shop_apparel_wrapper #lebanon_merch, #shop_apparel_wrapper #eliot_merch").addClass('hideme');

		/*=====Slider linking code=======*/
		$('#twocol_slider .swiper-slide').each(function () {
			const grabbtn_url = $(this).find('a.elementor-button').attr('href');
			var newstore_url = grabbtn_url;
			newstore_url = newstore_url.replace("/eliot-menu/", "/waterville-menu/");
			newstore_url = newstore_url.replace("/lebanon-menu/", "/waterville-menu/");
			$(this).find('a.elementor-button').attr('href', newstore_url);
		});

		$('#home_shop_grid_section .arrow_button').each(function () {
			const grabshopbtn_url = $(this).find('a').attr('href');
			var newshopstore_url = grabshopbtn_url;
			newshopstore_url = newshopstore_url.replace("/eliot-menu/", "/waterville-menu/");
			newshopstore_url = newshopstore_url.replace("/lebanon-menu/", "/waterville-menu/");
			$(this).find('a').attr('href', newshopstore_url);
		});
		/*=====Slider linking codee end=======*/

	}


	function getDataFromUrl() {
		var getDataName = $("#store_displaybtn span.elementor-button-text").attr('data-id');
		var getShopName = location.pathname.toLowerCase();
		getShopName = getShopName.split("/")[1]; // Get the second part of the pathname

		//  alert(getShopName);
		// alert(getDataName);

		if (getShopName === 'eliot-menu' || getShopName === 'lebanon-menu' || getShopName === 'waterville-menu') {
			//   alert('Yes, location match');
			window.location.href = "https://eccannabis.com/" + getDataName;
		} else {
			// You can add other actions here if the condition is not met
			//  alert('Location does not match');
		}
	}

	// Update cookie value on button click
	jQuery('.set-cookie').click(function () {
		var newValue = $(this).val();
		Cookies.set('myCookie', newValue);

		if (newValue == '8be63bcd-71d8-426d-8a38-752c547405e7') {
			jQuery("#store_displaybtn span.elementor-button-text").html('Eliot Menu');
			jQuery("#store_displaybtn span.elementor-button-text").attr('data-id', 'eliot-menu');
			jQuery("header .elementor-element.lebanon-menu, header .elementor-element.waterville-menu").hide();
			jQuery("header .elementor-element.eliot-menu").show();
			jQuery("#topright_menu ul li.menu-item.lebanon_shop_menu,#topright_menu ul li.menu-item.waterville_shop_menu").hide();
			jQuery("#topright_menu ul li.menu-item.eliot_shop_menu").css('display', 'flex');
			jQuery("#bestsellers_wrapper .bseller_eliot, #staff_picks_wrapper_home .staff_picks_eliot").removeClass('hideme');
			jQuery("#bestsellers_wrapper .bseller_lebanon,#bestsellers_wrapper .bseller_waterville, #staff_picks_wrapper_home .staff_picks_lebanon,#staff_picks_wrapper_home .staff_picks_waterville").addClass('hideme');

			jQuery("#shop_apparel_wrapper #eliot_merch").removeClass('hideme');
			jQuery("#shop_apparel_wrapper #lebanon_merch, #shop_apparel_wrapper #waterville_merch").addClass('hideme');

			jQuery("#popup").css("left", "-500px");
			getDataFromUrl();
			/*=====Slider linking code=======*/
			$('#twocol_slider .swiper-slide').each(function () {
				const grabbtn_url = $(this).find('a.elementor-button').attr('href');
				var newstore_url = grabbtn_url;
				newstore_url = newstore_url.replace("/lebanon-menu/", "/eliot-menu/");
				newstore_url = newstore_url.replace("/waterville-menu/", "/eliot-menu/");
				$(this).find('a.elementor-button').attr('href', newstore_url);
			});

			$('#home_shop_grid_section .arrow_button').each(function () {
				const grabshopbtn_url = $(this).find('a').attr('href');
				var newshopstore_url = grabshopbtn_url;
				newshopstore_url = newshopstore_url.replace("/lebanon-menu/", "/eliot-menu/");
				newshopstore_url = newshopstore_url.replace("/waterville-menu/", "/eliot-menu/");
				$(this).find('a').attr('href', newshopstore_url);
			});
			/*=====Slider linking codee end=======*/

		}
		else if (newValue == 'cd264a5c-b29d-40fc-8d1d-f677420cd0c5') {
			jQuery("#store_displaybtn span.elementor-button-text").html('Lebanon Menu');
			jQuery("#store_displaybtn span.elementor-button-text").attr('data-id', 'lebanon-menu');
			jQuery("header .elementor-element.eliot-menu, header .elementor-element.waterville-menu").hide();
			jQuery("header .elementor-element.lebanon-menu").show();
			jQuery("#topright_menu ul li.menu-item.eliot_shop_menu,#topright_menu ul li.menu-item.waterville_shop_menu").hide();
			jQuery("#topright_menu ul li.menu-item.lebanon_shop_menu").css('display', 'flex');
			jQuery("#bestsellers_wrapper .bseller_lebanon, #staff_picks_wrapper_home .staff_picks_lebanon").removeClass('hideme');
			jQuery("#bestsellers_wrapper .bseller_eliot,#bestsellers_wrapper .bseller_waterville, #staff_picks_wrapper_home .staff_picks_eliot,#staff_picks_wrapper_home .staff_picks_waterville").addClass('hideme');
			jQuery("#shop_apparel_wrapper #lebanon_merch").removeClass('hideme');
			jQuery("#shop_apparel_wrapper #eliot_merch, #shop_apparel_wrapper #waterville_merch").addClass('hideme');
			jQuery("#popup").css("left", "-500px");
			getDataFromUrl();

			/*=====Slider linking code=======*/
			$('#twocol_slider .swiper-slide').each(function () {
				const grabbtn_url = $(this).find('a.elementor-button').attr('href');
				var newstore_url = grabbtn_url;
				newstore_url = newstore_url.replace("/eliot-menu/", "/lebanon-menu/");
				newstore_url = newstore_url.replace("/waterville-menu/", "/lebanon-menu/");
				$(this).find('a.elementor-button').attr('href', newstore_url);
			});

			$('#home_shop_grid_section .arrow_button').each(function () {
				const grabshopbtn_url = $(this).find('a').attr('href');
				var newshopstore_url = grabshopbtn_url;
				newshopstore_url = newshopstore_url.replace("/eliot-menu/", "/lebanon-menu/");
				newshopstore_url = newshopstore_url.replace("/waterville-menu/", "/lebanon-menu/");
				$(this).find('a').attr('href', newshopstore_url);
			});
			/*=====Slider linking codee end=======*/

		}
		else if (newValue == 'd26049d4-9c0e-4dba-a43c-5e1103a3b8ee') {
			jQuery('#store_displaybtn span.elementor-button-text').html('Waterville Menu');
			jQuery("#store_displaybtn span.elementor-button-text").attr('data-id', 'waterville-menu');
			jQuery("header .elementor-element.lebanon-menu, header .elementor-element.eliot-menu").hide();
			jQuery("header .elementor-element.waterville-menu").show();
			jQuery("#topright_menu ul li.menu-item.lebanon_shop_menu,#topright_menu ul li.menu-item.eliot_shop_menu").hide();
			jQuery("#topright_menu ul li.menu-item.waterville_shop_menu").css('display', 'flex');
			jQuery("#bestsellers_wrapper .bseller_waterville, #staff_picks_wrapper_home .staff_picks_waterville").removeClass('hideme');
			jQuery("#bestsellers_wrapper .bseller_eliot,#bestsellers_wrapper .bseller_lebanon, #staff_picks_wrapper_home .staff_picks_eliot,#staff_picks_wrapper_home .staff_picks_lebanon").addClass('hideme');
			jQuery("#shop_apparel_wrapper #waterville_merch").removeClass('hideme');
			jQuery("#shop_apparel_wrapper #lebanon_merch, #shop_apparel_wrapper #eliot_merch").addClass('hideme');
			jQuery("#popup").css("left", "-500px");
			getDataFromUrl();

			/*=====Slider linking code=======*/
			$('#twocol_slider .swiper-slide').each(function () {
				const grabbtn_url = $(this).find('a.elementor-button').attr('href');
				var newstore_url = grabbtn_url;
				newstore_url = newstore_url.replace("/eliot-menu/", "/waterville-menu/");
				newstore_url = newstore_url.replace("/lebanon-menu/", "/waterville-menu/");
				$(this).find('a.elementor-button').attr('href', newstore_url);
			});

			$('#home_shop_grid_section .arrow_button').each(function () {
				const grabshopbtn_url = $(this).find('a').attr('href');
				var newshopstore_url = grabshopbtn_url;
				newshopstore_url = newshopstore_url.replace("/eliot-menu/", "/waterville-menu/");
				newshopstore_url = newshopstore_url.replace("/lebanon-menu/", "/waterville-menu/");
				$(this).find('a').attr('href', newshopstore_url);
			});
			/*=====Slider linking codee end=======*/

		}

	});
});

jQuery(document).ready(function ($) {
	jQuery('.dutchie-shop-filter.left_col_outer').prepend("<span class='closebtn'></span>");

	jQuery('.banner_right_headerbox .fillter_box_outer').click(function () {
		jQuery('.dutchie-shop-filter.left_col_outer span.closebtn').toggleClass("showicon");
		jQuery(".dutchie-shop-wrapper .left_col_outer .dutchie-filter-wrap, .dutchie-shop-wrapper .left_col_outer .vertical_nav_wrapper").toggle("slow");
		jQuery('body').toggleClass('noscroll');
	});

	jQuery('.dutchie-shop-filter.left_col_outer span.closebtn').click(function () {
		closeFilters();
	});

	jQuery('.filter-clear-btn').click(function () {
		closeFilters();
	});

	jQuery(document).on('click', '.filter-apply-clear-mobile .filter-apply-btn', function (e) {
		closeFilters();
	});

	jQuery(document).on('change', '#dutchie-sort-by', function (e) {
		e.preventDefault();
		var sortBy = jQuery(this).val();
		jQuery('.dutchie-filter-wrap input[name="sortby"]').val(sortBy);
		if (jQuery(window).width() < 991) {
			// for some reason this was in the plugin but set to > 991
			// no clue why that would be so this is here to make it work on mobile
			jQuery('.dutchie-filter-wrap input[name="sortby"]').closest('form').submit();
		}

		if (jQuery('.dutchie-shop-filter.left_col_outer span.closebtn').hasClass("showicon")) {
			closeFilters();
		}
	})
});

const closeFilters = () => {
	jQuery(".dutchie-shop-wrapper .left_col_outer .dutchie-filter-wrap, .dutchie-shop-wrapper .left_col_outer .vertical_nav_wrapper").toggle("slow");
	jQuery('.dutchie-shop-filter.left_col_outer span.closebtn').toggleClass("showicon");
	jQuery('body').toggleClass('noscroll');
}
